import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/header/styles.scss';export default {
  "header": "_header_1jgen_1",
  "label": "_label_1jgen_14",
  "center": "_center_1jgen_21",
  "removeAllocation": "_removeAllocation_1jgen_26",
  "actions": "_actions_1jgen_31"
};